import endpoint from '@app/endpoint';
import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LocalizedText from '@LocalizedText';
import { setFooterConfig } from '@app/actions/footerActions';
import { addError } from '@app/actions/popupsActions';
import { startLoading, endLoading } from '@app/actions/spinnerActions';
import { APPLY_CODES_FLOW_SELECTION, AUTHORIZATION_SENT, REQUEST_CODES_FLOW } from '@app/constants';
import AuthorizeCodesForm from './AuthorizeCodesForm';
import './AuthorizeCodes.scss';

const serializeData = data => {
  let serializedData = '';
  for (let field in data) {
    serializedData += `${encodeURIComponent(field)}=${encodeURIComponent(data[field])}&`;
  }
  return serializedData;
};

const AuthorizeCodes = ({ brandIdList = [], selectApplyCodesStep, setFooterConfig, addError, startLoading, endLoading }) => {
  const [isFormValid, setIsFormValid] = useState(false);
  const [formData, setFormData] = useState({});

  const returnToApplyCodesFlowSelection = useCallback(() => {
    selectApplyCodesStep(APPLY_CODES_FLOW_SELECTION);
  }, [selectApplyCodesStep]);

  const returnToRequestCodesFlow = useCallback(() => {
    selectApplyCodesStep(REQUEST_CODES_FLOW);
  }, [selectApplyCodesStep]);

  const navigateToFinishStep = useCallback(() => {
    selectApplyCodesStep(AUTHORIZATION_SENT);
  }, [selectApplyCodesStep]);

  const handleFormSubmit = useCallback(() => {
    if (!isFormValid) return;
    const data = serializeData(formData);
    startLoading();
    endpoint.sendTspEmail(
      data,
      () => {
        endLoading();
        navigateToFinishStep();
      },
      () => {
        endLoading();
        addError('qau-authorization-not-sent');
      },
    );
  }, [addError, endLoading, formData, isFormValid, navigateToFinishStep, startLoading]);

  useEffect(() => {
    setFooterConfig({
      visible: true,
      backHidden: false,
      nextHidden: false,
      onBack: returnToApplyCodesFlowSelection,
      onNext: handleFormSubmit,
      nextDisabled: !isFormValid,
      nextLocKey: 'qau-authorize-btn',
    });
  }, [setFooterConfig, returnToApplyCodesFlowSelection, handleFormSubmit, isFormValid]);

  useEffect(() => {
    if (brandIdList.length > 0) {
      returnToRequestCodesFlow();
    }
  }, [brandIdList, returnToRequestCodesFlow]);

  return (
    <div id="qau-authorize-codes">
      <div className="authorize-codes-title">
        <LocalizedText id="qau-authorize-codes-title" />
      </div>
      <div className="authorize-codes-description">
        <LocalizedText id="qau-authorize-codes-description" />
      </div>
      <AuthorizeCodesForm setFormValid={setIsFormValid} setFormData={setFormData} />
    </div>
  );
};

const mapStateToProps = ({ applyCodes: { brandIdList } }) => ({ brandIdList });

const mapDispatchToProps = {
  setFooterConfig,
  addError,
  startLoading,
  endLoading,
};

AuthorizeCodes.propTypes = {
  brandIdList: PropTypes.array,
  setFooterConfig: PropTypes.func.isRequired,
  selectApplyCodesStep: PropTypes.func.isRequired,
  addError: PropTypes.func.isRequired,
  startLoading: PropTypes.func.isRequired,
  endLoading: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthorizeCodes);
